<template>
<div>
      <div :class="[preClass ,'container']">
          <van-tabs v-model="label">
          <van-tab :name="key" :title="key"  v-for="(item, key) of currencyAnalysis" :key="key">
            <base-table :data="item"></base-table>
          </van-tab>
        </van-tabs>
        <subjectDetail   ref="detail" :title="title" :label='label'></subjectDetail>
    </div>
</div>

</template>

<script>
import { mapGetters } from "vuex";
import subjectDetail from '@/components/commons/subject-detail'

export default {
  components:{subjectDetail},
  data() {
    return {
      preClass: "currency-analyse",
      currencyAnalysis:[],
      label:'银行存款'
    };
  },
    computed: {
    ...mapGetters(["currClient", "currDate"]),
    title(){
      return  this.currDate.substr(0,7).replace('-','/')+this.label+'发生明细'
    }

  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$store.commit('app/SET_LOADING_STATUS', true)
      let params = {
        begin_date: this.currDate,
        end_date: this.currDate,
        report_type: 3
      };
      this.$axios.post("/report/boss-report/get-report", params).then(res => {
        console.log("货币资金分析", res);
        if (res.success && res.rows) {
          let tabsData = {};
          res.rows.forEach(item => {
            item = {
              ...item,
              title:item.name,
              value:item.formula,
              align: "around",
              click: this.handleTableClick,
              filter: "toThousandFilter",
              color: "blue"
            };
            if (item.key_type) {
              if (tabsData[item.key_type]) {
                tabsData[item.key_type].push(item);
              } else {
                tabsData[item.key_type] = [item];
              }
            }
          });
          this.currencyAnalysis = tabsData;
        }
      }).finally(_=>{
          this.$store.commit('app/SET_LOADING_STATUS', false)

      });
    },
    handleTableClick(){
      this.$refs.detail.show = true
    }
  }
};
</script>

<style lang='less'>
.currency-analyse{
  &-title{

  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/financial-report/currency-analyse/index.vue